const ITEMS = ["Кетъринг", "Събития", "Координация", "Декорация"];

const Row = () => (
  <>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-8 md:gap-12">
        <span className="font-serif text-2xl font-light italic tracking-wide text-brand-dark/75 md:text-4xl">
          {t}
        </span>
        <span className="text-sm text-brand-accent md:text-base" aria-hidden="true">
          ✦
        </span>
      </span>
    ))}
  </>
);

export const Marquee = () => (
  <div
    aria-hidden="true"
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-brand-border bg-brand-bg py-6 md:py-8"
  >
    <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap md:gap-12">
      <div className="flex items-center gap-8 md:gap-12">
        <Row />
        <Row />
      </div>
      <div className="flex items-center gap-8 md:gap-12">
        <Row />
        <Row />
      </div>
    </div>
  </div>
);
